import {
  providerOptinPaidLeads, removeLead, providerOptOut,
  fetchNewLeadsCount, markSeen,
} from './leads.service';

export default {
  namespaced: true,
  state: {
    optedInPaidLeads: false,
    optedOutPaidLeads: false,
    newLeadsCount: 0,
  },
  getters: {
    optedInPaidLeads(state) {
      return state.optedInPaidLeads;
    },
  },
  mutations: {
    setOptedInPaidLeads: (state, optedIn) => {
      state.optedInPaidLeads = optedIn;
    },
    setOptedOutPaidLeads: (state, optedOut) => {
      state.optedOutPaidLeads = optedOut;
    },
    setNewLeadsCount: (state, count) => {
      state.newLeadsCount = count;
    },
  },
  actions: {
    async removeLead({ dispatch, commit }, { centerId, childId }) {
      try {
        const data = await removeLead({ centerId, childId });
        if (data.success) {
          commit('families/removeFamily', childId, { root: true });
          dispatch('notifications/addToastNotification', { text: 'Lead removed' }, { root: true });
        } else {
          dispatch('notifications/addToastError', { text: data.error }, { root: true });
        }
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Failed to remove lead', error }, { root: true });
      }
    },
    async providerOptinPaidLeads({ dispatch, commit }, paymentMethodId) {
      try {
        const data = await providerOptinPaidLeads(paymentMethodId);
        if (data.success) {
          commit('setOptedInPaidLeads', true);
          commit('setOptedOutPaidLeads', false);
          dispatch('notifications/addToastNotification', { text: 'Success! Opted-in leads' }, { root: true });
        } else {
          dispatch('notifications/addToastError', { text: data.error }, { root: true });
        }
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Failed to optin', error }, { root: true });
      }
    },
    async providerOptOut({ dispatch, commit }) {
      try {
        const data = await providerOptOut();
        if (data.success) {
          commit('setOptedInPaidLeads', false);
          commit('setOptedOutPaidLeads', true);
        } else {
          dispatch('notifications/addToastError', { text: data.error }, { root: true });
        }
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Failed', error }, { root: true });
      }
    },
    async fetchNewLeadsCount({ dispatch, commit }) {
      try {
        const data = await fetchNewLeadsCount();
        commit('setNewLeadsCount', data?.count || 0);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could fetch new leads count', error }, { root: true });
        throw new Error(error);
      }
    },
    async markSeen({ commit, dispatch }, centerId) {
      try {
        const response = await markSeen({ centerId });
        if (response.status !== 200) {
          dispatch('notifications/addToastError', { text: 'Could not mark leads as seen' }, { root: true });
        }
        commit('setNewLeadsCount', response.data?.count || 0);
      } catch (error) {
        dispatch('notifications/addToastError', { text: 'Could not mark leads as seen', error }, { root: true });
      }
    },
  },
};
